import React from "react";
import { makeStyles, Theme } from "@material-ui/core/styles";
import Backdrop, { BackdropProps } from "@material-ui/core/Backdrop";
import Container from "@material-ui/core/Container";
import Paper from "@material-ui/core/Paper";
import clsx from "clsx";

import LightLoginForm, { LoginFormValues } from "./LightLoginForm";
import useAuth from "../../hooks/useAuth";

const useStyles = makeStyles((theme: Theme) => ({
  /* Styles applied to the root element. */
  root: {
    width: "100%",
    height: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    zIndex: theme.zIndex.appBar - 1,
  },
}));

export type LightLoginProps = Omit<BackdropProps, "open"> & {};

function LightLogin(props: LightLoginProps) {
  const { className, ...other } = props;
  const classes = useStyles();
  const rootClasses = React.useMemo(() => {
    return clsx(classes.root, className);
  }, [className, classes.root]);
  const { authenticationService, loggedIn, logout } = useAuth();
  const [open, setOpen] = React.useState(false);

  // When the user is logged out and the keep session open flag is set to `"1"`,
  // open the light login form.
  React.useEffect(() => {
    if (loggedIn === true) return;

    const { keepSessionOpen } = authenticationService.getUserCredentials();

    if (keepSessionOpen !== "1") {
      if (process.env.NODE_ENV !== "production") {
        console.error(`The keep session open flag is unset are false.`);
      }
      logout("hard");
      return;
    }

    setOpen(true);
  }, [authenticationService, loggedIn, logout]);

  const handleLightLoginFormSubmitSuccess = React.useCallback(
    (_data: LoginFormValues, _event?: React.BaseSyntheticEvent) => {
      setOpen(false);
    },
    []
  );

  return (
    <Backdrop className={rootClasses} open={open} {...other}>
      <Container maxWidth="sm">
        <Paper>
          {open && (
            <LightLoginForm
              onSubmitSuccess={handleLightLoginFormSubmitSuccess}
            />
          )}
        </Paper>
      </Container>
    </Backdrop>
  );
}

export default LightLogin;
